import { addDisplayName, flowMax } from 'ad-hok'
import { FC } from 'react'
import { CategoryInput } from 'shared/src/api/types'

import { addTranslationHelpers } from 'utils/addTranslationHelpers'
import { FormProps } from './resource'
import { NumberField, TextField } from './TextField'
import { ImageField } from './ImageField'

export interface FormValues extends Omit<Partial<CategoryInput>, 'position'> {
  position?: string
}

export const CategoriesForm: FC<FormProps<FormValues>> = flowMax(
  addDisplayName('CategoriesForm'),
  addTranslationHelpers,
  ({ values, onChange, errors, t }) => (
    <div>
      <TextField
        id="name"
        label={t('admin.resources.categories.fields.name')}
        value={values.name ?? ''}
        onChange={(name) => onChange({ ...values, name })}
        error={errors.name}
        focusOnMount
      />
      <NumberField
        id="position"
        label={t('admin.resources.categories.fields.position')}
        value={values.position}
        onChange={(position) => onChange({ ...values, position })}
        error={errors.position}
      />
      <ImageField
        id="imageId"
        label={t('admin.resources.categories.fields.imageId')}
        value={values.imageId}
        onChange={(imageId) => onChange({ ...values, imageId })}
        error={errors.imageId}
      />
    </div>
  )
)
